export default "__VITE_ASSET__ydoDzVHA__"